/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multi_Select_HintInputs */



/**
* | output |
* | --- |
* | "Click to select. Ctrl/Cmd-click to toggle. Shift-click to select a range." |
*
* @param {Multi_Select_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multi_select_hint = /** @type {((inputs?: Multi_Select_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multi_Select_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez pour sélectionner. Ctrl/Cmd+clic pour basculer. Maj+clic pour sélectionner une plage.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken zum Auswählen. Strg/Cmd+Klick zum Umschalten. Umschalt+Klick für Bereichsauswahl.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clicca per selezionare. Ctrl/Cmd+clic per attivare/disattivare. Shift+clic per selezionare un intervallo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кликните для выбора. Ctrl/Cmd+клик — переключить. Shift+клик — выбрать диапазон.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic para seleccionar. Ctrl/Cmd+clic para alternar. Mayús+clic para seleccionar un rango.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("单击以选择。Ctrl/Cmd+单击以切换。Shift+单击以选择范围。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリックで選択。Ctrl/Cmd+クリックで切り替え。Shift+クリックで範囲を選択。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयन करने के लिए क्लिक करें। टॉगल करने के लिए Ctrl/Cmd+क्लिक करें। श्रेणी चुनने के लिए Shift+क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique para selecionar. Ctrl/Cmd+clique para alternar. Shift+clique para selecionar um intervalo.")
	return /** @type {LocalizedString} */ ("Click to select. Ctrl/Cmd-click to toggle. Shift-click to select a range.")
});